import { FC, memo } from "react";
import { TableCell, TableRow } from "@material-ui/core";
import { ScheduleTableColumn } from "pages/Schedule/scheduleTable";
import { ScheduleUserData } from "types/Schedule";
import { ScheudlePdfRenderCell } from "./ScheudlePdfRenderCell";

interface ScheudlePdfRenderRowProps {
  user: ScheduleUserData;
  columns: ScheduleTableColumn[];
  classes: any;
}

export const ScheudlePdfRenderRow: FC<ScheudlePdfRenderRowProps> = memo(
  ({ user, columns, classes }) => {
    return (
      <TableRow data-testid="testPdfRenderRow">
        {columns.map((column, index) => (
          <TableCell
            key={`schedule-pdf-cell-${column.id}-${user.id}`}
            className={`${classes.tableCell} ${index > 0 ? classes.tableBorderLeft : ""}`}
          >
            <ScheudlePdfRenderCell
              columnId={column.id}
              userData={user}
              date={column.date}
              classes={classes}
            />
          </TableCell>
        ))}
      </TableRow>
    );
  },
);
